import type { Credentials } from './login.model';

/** Field-level validation errors for the credentials step. Empty = valid. */
export type CredentialsErrors = Partial<Record<keyof Credentials, string>>;

/** The OTP code length the backend expects (`VerifyOtpRequestSchema.code.length(6)`). */
export const OTP_LENGTH = 6;

/**
 * Pure business validation for the credentials step. Mirrors the original page's
 * gate (`disabled={!email || !password}`): both fields non-empty. No format
 * regex; the backend validates the email and the credentials themselves.
 */
export function validateCredentials(c: Credentials): CredentialsErrors {
  const errors: CredentialsErrors = {};
  if (!c.email.trim()) errors.email = 'An email address is required.';
  if (!c.password) errors.password = 'A password is required.';
  return errors;
}

/** Is the 6-digit OTP fully entered? (all slots filled, joined length 6). */
export function validateOtp(code: string[]): boolean {
  return code.every((d) => d !== '') && code.join('').length === OTP_LENGTH;
}
